import { render, staticRenderFns } from "./BuildDetailed.vue?vue&type=template&id=a7344862&"
import script from "./BuildDetailed.vue?vue&type=script&lang=js&"
export * from "./BuildDetailed.vue?vue&type=script&lang=js&"
import style0 from "./BuildDetailed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports